import * as React from "react"
const QuoteGreenIcon = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={55}
    height={55}
    fill="green"
    {...props}
  >
    <path
      fill="url(#green)"
      d="M54.3 17.2C52.05 7.6 46.8 2.95 43.2 2.95c-9.45 0-17.55 23.4-17.55 31.65 0 4.8 1.35 9 1.35 14.7 3 0 2.85 1.65 2.85 5.1 9.45-7.35 15.3-26.1 22.5-37.2h1.95Zm-29.55-3C24 7 19.95.7 15.45.7 9.75.7 2.4 13.45.75 21.25c1.5 8.1 3.45 14.25 7.2 18.9l1.5-1.8c2.1 2.4 2.55 3.75 1.8 5.25 1.2 1.05 2.55 1.8 4.05 2.55C16.5 34.3 9.75 27.7 24.75 14.2Z"
    />
    <defs>
      <linearGradient
        id="green"
        x1={4.5}
        x2={38.776}
        y1={-1.5}
        y2={45.346}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6AC288" />
        <stop offset={1} stopColor="#95DA38" />
      </linearGradient>
    </defs>
  </svg>
)
export default QuoteGreenIcon
